import React from 'react';
import { Col, Row } from 'react-bootstrap';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { filterConfig } from '../config/filterConfig';

const MotoristaFilter = ({ loading, onApply, onLimpar }) => (
  <Row>
    <Col md={12}>
      <FilterPanel
        filters={filterConfig}
        onApply={onApply}
        onLimpar={onLimpar}
        title="Filtros de Motoristas"
        loading={loading}
        defaultCollapsed
      />
    </Col>
  </Row>
);

export default MotoristaFilter;
